import { ColumnDef, ExpandedState, OnChangeFn, RowSelectionState, SortingFn } from '@tanstack/react-table'
import React from 'react'
import DataTable, { getGroupStyle } from './DataTable'
import { DataTableColumnMeta } from './DataTable.types'

export type Column = {
  header: string
  accessorKey: string
  footer?: string
  cell?: ({}: any) => string | JSX.Element
  sortingFn?: SortingFn<any>
}

interface ReactTableProps<T> {
  data: T[]
  columns: ColumnDef<T, any>[]
  hiddenColumns?: Record<string, boolean>
  footerTop?: boolean
  defaultSort?: Array<{ desc: boolean; id: string }>
  defaultExpanded?: ExpandedState
  useGroupStyle?: boolean
  darkHeader?: boolean
  enablePagination?: boolean
  rowSelection?: RowSelectionState
  setRowSelection?: OnChangeFn<RowSelectionState>
  onClick?: (props: T) => void
  stickyHeader?: boolean
  stickyTopPosition?: string
  /** Only applies when `withContainer` is false. */
  scrollX?: boolean
}

export type MetaType = DataTableColumnMeta<any>
export { getGroupStyle }

const ReactTable = <T,>({
  data,
  columns,
  hiddenColumns = {},
  footerTop = false,
  defaultSort = [],
  defaultExpanded = {},
  useGroupStyle = false,
  darkHeader = false,
  enablePagination = false,
  rowSelection = {},
  setRowSelection,
  onClick,
  stickyHeader = false,
  stickyTopPosition = '0px',
  scrollX = false,
}: ReactTableProps<T>): React.ReactElement => {
  return (
    <DataTable
      columnVisibility={hiddenColumns}
      columns={columns}
      darkHeader={darkHeader}
      data={data}
      defaultExpanded={defaultExpanded}
      defaultSorting={defaultSort}
      enablePagination={enablePagination}
      footerTop={footerTop}
      onClick={onClick}
      rowSelection={rowSelection}
      scrollX={scrollX}
      setRowSelection={setRowSelection}
      stickyHeader={stickyHeader}
      stickyTopPosition={stickyTopPosition}
      useGroupStyle={useGroupStyle}
      withContainer={false}
    />
  )
}

export default ReactTable
